import React from 'react';
import { NavLink } from 'react-router-dom';
import { RequestIdTableCell } from '../RequestIdTableCell';

export const RequestId = {
    Header: () => 'Solicitud',
    id: 'id',
    typeId: 'HeaderRequest',
    Cell: ({ row }) => {
        return <RequestIdTableCell row={row} />;
    },
};

export const RequestIdWithoutRedirect = {
    Header: () => 'Solicitud',
    id: 'id',
    Cell: ({ row }) => {
        return (
            <NavLink to="#" className="finamiga-color">
                {' '}
                <span className="box-state">{row.original.pk}</span>
            </NavLink>
        );
    },
};

export const RequestIdKiva = {
    Header: () => 'Solicitud',
    id: 'id',
    Cell: ({ row }) => {
        return (
            <NavLink
                to={`/app/credits/list/process/${row.original.identificacion}/${row.original.solicitud}/${row.original.id_persona}`}
                className="finamiga-color">
                {' '}
                <span className="box-state">{row.original.solicitud}</span>
            </NavLink>
        );
    },
};


export const RequestIdMonitoring = {
    Header: () => 'Solicitud',
    id: 'id',
    Cell: ({ row }) => {
        return (
            <NavLink
                to={`/app/credits/list/process/${row.original.persona.numero_identificacion}/${row.original.pk}/${row.original.persona.pk}`}
                className="finamiga-color">
                {' '}
                <span className="box-state">{row.original.pk}</span>
            </NavLink>
        );
    },
};
